import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import { gridNumberFormatter, formattedNumberValueGetter } from '../../../components/ValueFormatters';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { COUNTRY_VIDEO_REPORT_ID } from './countryVideoReportId';

const countryReportColumnDefinition = [
    {
        headerName: FIELDS.COUNTRY_CODE.label,
        field: FIELDS.COUNTRY_CODE.field,
        type: [leftPinnedColumn],
        cellRenderer: FIELDS.COUNTRY_CODE.cellRenderer,
        cellRendererParams: FIELDS.COUNTRY_CODE.renderParams,
        csvValueGetter: FIELDS.COUNTRY_CODE.csvValueGetter,
    },
    ...[
        FIELDS.SPENT,
        FIELDS.COMPLETED_VIEWS,
        FIELDS.VIDEO_IMPRESSIONS,
        FIELDS.VIDEO_VISIBLE_IMPRESSIONS,
        FIELDS.VIDEO_CPM,
        FIELDS.VIDEO_VCPM,
        FIELDS.CPCV,
        FIELDS.VIEWABILITY_RATE,
        FIELDS.HUNDRED_PCT_VIEWABILITY_RATE,
        FIELDS.COMPLETION_RATE,
        FIELDS.CLICKS,
        FIELDS.VIDEO_CTR,
        FIELDS.VIDEO_VCTR,
        FIELDS.CPA,
        FIELDS.VIDEO_CVR,
        FIELDS.CONVERSIONS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(countryReportColumnDefinition, COUNTRY_VIDEO_REPORT_ID);
